import { TApplicationState } from '../../types/redux';

export function getHasProgressOfConstruction(state: TApplicationState) {
  const {
    newbuilding: { hasProgressOfConstruction },
  } = state;

  return hasProgressOfConstruction;
}
